<template>
  <v-col class="px-0 pt-0">
    <v-row v-if="dialog" style="margin:-16px" class="p-3">
      <p class="text-center align-self-center mb-0 text-20 ps-2">{{ contactName }}</p>
      <v-spacer></v-spacer>
      <v-icon @click="closeDialog" class="text-center align-self-center">
        fas fa-xmark
      </v-icon>
    </v-row>
    <div ref="CHAT_CONTAINER" class="container-style mb-5 pt-4">
      <v-col v-for="(item, index) in chatItems" :key="index">
        <p v-if="date = getDate(item.date, index)" class="text-center mb-2 system">
          {{ date }}
        </p>

        <v-row :class="isSender(item.contactId) ? 'flex-row-reverse' : ''">
          <div class="d-flex align-center" style="max-width: 70%;">
            <div :class="chatItemClass(item)">
              <div>
                <p :class=textClass(item)>
                  {{ item.label }}
                </p>
              </div>
            </div>
          </div>
        </v-row>
      </v-col>
    </div>

    <v-row class="m-0 chat-input">
      <v-textarea background-color="white" v-model="message" rows="1"
                  rounded hide-details auto-grow dense color="#033" @keydown.enter.exact.prevent="sendMessage()"
                  @keydown.enter.alt.exact.prevent="message += '\n'">
        <template v-slot:append-inner>
          <div @click="sendMessage()" :style="{'color': message == '' ? 'rgb(var(--v-theme-primary0))': 'rgb(var(--v-theme-primary50))',
  fontWeight: 'bold'}"
               class="btn-envoyer p-2 pe-4">
            Envoyer
          </div>
        </template>
      </V-textarea>


    </v-row>
  </v-col>
</template>
<script lang="ts">
import ChatItem from '@/generated/classes/ChatItem';
import {defineComponent, nextTick, type PropType} from "vue";

export default defineComponent({
  components: {},
  props: {
    chatItems: {
      type: Array as PropType<ChatItem[]>
    },
    userId: {
      type: Number
    },
    contactName: {
      type: String
    },
    dialog: {
      type: Boolean
    }
  },
  data() {
    return {
      message: '',
    };
  },
  methods: {
    getDate(item: Date, index: number): string | null {
      const currentDate = new Date(item)
      if (index !== 0 && this.chatItems) {
        const previousDate = new Date(this.chatItems[index - 1].date);
        const diff = Math.abs(currentDate.getTime() - previousDate.getTime()) / 1000 / 60 / 60;
        if (diff > 1) {
          return this.formatDate(currentDate);
        } else {
          return null
        }
      } else {
        return this.formatDate(currentDate);
      }
    },
    formatDate(dateTime: Date): string {
      const diffDays = new Date().getDate() - dateTime.getDate();
      const diffMonths = new Date().getMonth() - dateTime.getMonth()
      const diffYears = new Date().getFullYear() - dateTime.getFullYear();
      const time = dateTime.getHours().toString().padStart(2, '0') + ':' + dateTime.getMinutes().toString().padStart(2, '0');
      let res = '';
      if (diffYears == 0 && diffDays == 0 && diffMonths == 0) {
        res = "Aujourd'hui à " + time;
      } else if (diffYears == 0 && diffDays == 1) {
        res = "Hier à " + time;
      } else if (diffYears == 0 && diffDays > 1 && diffDays < 7) {
        const day = dateTime.toLocaleDateString('FR-fr', {weekday: 'long'});
        const nameCapitalized = day.charAt(0).toUpperCase() + day.slice(1)
        res = nameCapitalized + ' à ' + time
      } else {
        let month = (dateTime.getMonth() + 1).toString();
        if (month.length == 1) {
          month = '0' + month
        }
        res = dateTime.getDate() + '/' + month + '/' + dateTime.getFullYear() + ' à ' + time;
      }
      return res;
    },
    isSender(contactId: number): boolean {
      if (contactId == this.userId) {
        return true;
      }
      return false;
    },
    sendMessage(): void {
      if (this.message) {
        this.$emit('sendMessage', this.message);
        this.message = '';
        this.updated();
      }
    },
    scrollToEnd() {
      const container = this.$refs.CHAT_CONTAINER;
      nextTick(() => {
        if (container) {
          // @ts-expect-error : generated method
          container.scrollTop = container.scrollHeight;
        }
      })
    },
    updated() {
      this.scrollToEnd()
    },
    chatItemClass(item: ChatItem): string {
      let res = '';
      if (this.isSender(item.contactId)) {
        res = 'sender';
      } else {
        res = 'receiver';
      }

      if (item.isSystem) {
        res += ' system';
      }
      return res;
    },
    textClass(item: ChatItem): string {
      let res = '';
      if (this.isSender(item.contactId)) {
        res = 'sender-text';
      } else {
        res = 'receiver-text';
      }

      if (item.isSystem) {
        res += ' system';
      }
      return res;
    },
    closeDialog() {
      this.$emit('closeDialog')
    }
  }
})

</script>

<style scoped>
.container-style {
  height: 45vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.sender-text {
  color: white;
  text-align: end;
  margin-bottom: 0;
  white-space: pre-wrap;
}

.receiver-text {
  color: #E42724;
  text-align: start;
  margin-bottom: 0;
  white-space: pre-wrap;
}

.sender {
  position: relative;
  background: #E42724;;
  border-radius: 15px;
  padding: 10px;
  margin-top: 2px;
}

.system {
  background: none !important;
  color: #707070 !important;
  font-size: 0.75rem;
  border: none !important;
}

.receiver {
  position: relative;
  border-radius: 15px;
  border: 1px solid #E42724;
  padding: 10px;
  margin-top: 5px;
}

::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: none;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: none;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: none;
}

.chat-input {
  border-radius: 15px !important;
  border: 1px solid rgb(167, 167, 167);
}

.test2 .chat-input .v-input__append-outer {
  margin-top: 0 !important;
}

.btn-envoyer {
  cursor: pointer;
}
</style>
